export default {
  userProfile: {
    header: {
      title: "Profileinstellungen",
      subtitle: "Verwalte dein Linemate-Profil",
    },
    sections: {
      accountDetails: "Kontodetails",
      billing: "Abrechnung",
    },
    labels: {
      oldPassword: "Altes Passwort",
      newPassword: "Neues Passwort",
      confirmNewPassword: "Neues Passwort bestätigen",
      enterYourPassword: "Passwort eingeben",
      showAll: "Alle anzeigen",
    },
    descriptions: {
      changePassword: "Ändere das Passwort deines Linemate-Kontos",
      preferredOdds: "Wähle deine bevorzugten Quoten für Trends und Meine Tipps",
      language: "Wähle die Sprache aus, in der Linemate angezeigt werden soll.",
      odds: "Wähle das Format aus, in dem Quoten angezeigt werden sollen.",
      theme: "Wähle aus, wie Linemate angezeigt wird.",
      billingPrimary: "Behalte deinen Plan und Zahlungsoptionen im Blick",
      billingSecondary: "Linemate arbeitet mit Stripe zusammen, um Abrechnung und Zahlungsverwaltung zu vereinfachen.",
      deleteAccount: "Konto und Kontodaten löschen",
      deleteAccountSecondary: "Wenn du dein Konto dauerhaft löschen möchtest, kannst du das rechts tun.",
    },
    actions: {
      update: "Aktualisieren",
      choosePreferredOdds: "Bevorzugte Quoten auswählen",
      saveMyChoices: "Auswahl speichern",
      manageBilling: "Abrechnung verwalten",
      deleteThisAccount: "Dieses Konto löschen",
    },
    deleteAccount: {
      confirmMessage: "Möchtest du dein Konto wirklich löschen? Wenn ja, fahre bitte unten fort.",
      permanentWarning: "Beachte, dass alle deine Daten dauerhaft von unseren Servern entfernt werden. Diese Aktion beendet dein Abo für den nächsten Abrechnungszeitraum und kann nicht rückgängig gemacht werden.",
      acknowledgment: "Ich bestätige, dass alle Daten dieses Kontos gelöscht werden, und möchte fortfahren.",
    },
    validation: {
      passwordRequirements: "Das Passwort muss einen Großbuchstaben, einen Kleinbuchstaben und mindestens 8 Zeichen enthalten.",
      confirmPasswordMismatch: "Die Passwortbestätigung stimmt nicht überein.",
      incorrectPassword: "Falsches Passwort.",
    },
  },
};
